import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_interaction_Draw from 'ol/interaction/Draw';
import { Util } from "../util";
import Map from '../map';

export class Draw extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            clickTolerance: undefined,
            features: undefined,
            source: undefined,
            snapTolerance: undefined,
            type: undefined,
            maxPoints: undefined,
            minPoints: undefined,
            finishCondition: undefined,
            style: undefined,
            geometryFunction: undefined,
            geometryName: undefined,
            condition: undefined,
            freehand: undefined,
            freehandCondition: undefined,
            wrapX: undefined
        };
        this.events = {
            'change': undefined,
            'change:active': undefined,
            'drawend': undefined,
            'drawstart': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.interaction = new ol_interaction_Draw(options);
        this.context.mapComp.interactions.push(this.interaction);
        this.context.mapComp.map.addInteraction(this.interaction); //hoan add dong này
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.interaction.on(eventName, olEvents[eventName]);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.context.mapComp.map.removeInteraction(this.interaction);
            let options = Util.getOptions(Object['assign'](this.options, nextProps));
            this.interaction = new ol_interaction_Draw(options);
            this.context.mapComp.map.addInteraction(this.interaction);
            let olEvents = Util.getEvents(this.events, this.props);
            for (let eventName in olEvents) {
                this.interaction.on(eventName, olEvents[eventName]);
            }
        }
    }
    componentWillUnmount() {
        this.context.mapComp.map.removeInteraction(this.interaction);
    }
}
Draw['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};